import { render, staticRenderFns } from "./navsHg.vue?vue&type=template&id=4e620f5d&"
import script from "./navsHg.vue?vue&type=script&lang=js&"
export * from "./navsHg.vue?vue&type=script&lang=js&"
import style0 from "./navsHg.vue?vue&type=style&index=0&id=4e620f5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports